import { useEffect } from "react";
import { SITE_URL } from "@/data/seoPages";

const setMeta = (selector, attribute, value) => {
  const element = document.head.querySelector(selector);
  if (element) element.setAttribute(attribute, value);
};

export const usePageSeo = ({ title, description, path, schema, noindex = false }) => {
  const schemaJson = schema ? JSON.stringify(schema) : "";
  useEffect(() => {
    const canonicalUrl = `${SITE_URL}${path}`;
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[name="robots"]', "content", noindex ? "noindex, nofollow" : "index, follow");
    setMeta('link[rel="canonical"]', "href", canonicalUrl);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", canonicalUrl);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);

    let script = document.head.querySelector('#page-structured-data');
    if (schemaJson) {
      if (!script) {
        script = document.createElement("script");
        script.id = "page-structured-data";
        script.type = "application/ld+json";
        document.head.appendChild(script);
      }
      script.textContent = schemaJson;
    } else {
      script?.remove();
    }
  }, [description, noindex, path, schemaJson, title]);
};